import React from 'react';
import { Heart } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-dark text-white/70 py-12 border-t border-white/10" data-id="element-140">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-141">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-142">
          {/* Brand */}
          <div className="md:col-span-2" data-id="element-143">
            <div className="flex items-center gap-2 mb-4" data-id="element-144">
              <Heart className="h-6 w-6 text-primary fill-primary" data-id="element-145" />
              <span className="font-heading font-bold text-xl text-white tracking-tight" data-id="element-146">
                Small Big Emotions
              </span>
            </div>
            <p className="max-w-sm text-sm leading-relaxed" data-id="element-147">
              Helping children understand, manage, and express their emotions
              through the power of play. No screens, just connection.
            </p>
          </div>

          {/* Links */}
          <div data-id="element-148">
            <h4 className="text-white font-heading font-bold mb-4" data-id="element-149">Product</h4>
            <ul className="space-y-2 text-sm" data-id="element-150">
              <li data-id="element-151">
                <a href="#included" className="hover:text-white transition-colors" data-id="element-152">
                  What's Included
                </a>
              </li>
              <li data-id="element-153">
                <a href="#how-it-works" className="hover:text-white transition-colors" data-id="element-154">
                  How It Works
                </a>
              </li>
              <li data-id="element-155">
                <a href="#reviews" className="hover:text-white transition-colors" data-id="element-156">
                  Reviews
                </a>
              </li>
              <li data-id="element-157">
                <a href="#faq" className="hover:text-white transition-colors" data-id="element-158">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-159">
            <h4 className="text-white font-heading font-bold mb-4" data-id="element-160">Legal</h4>
            <ul className="space-y-2 text-sm" data-id="element-161">
              <li data-id="element-162">
                <a href="#" className="hover:text-white transition-colors" data-id="element-163">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-164">
                <a href="#" className="hover:text-white transition-colors" data-id="element-165">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-166">
          <p data-id="element-167">© {currentYear} Small Big Emotions. All rights reserved.</p>
          <p className="flex items-center gap-1" data-id="element-168">
            Made with <Heart className="w-4 h-4 text-primary fill-primary" data-id="element-169" />{' '}
            for families everywhere
          </p>
        </div>
      </div>
    </footer>;
}